import { css } from '@emotion/react';
import { StylesConfig } from 'react-select';

import { themeStyled as styled } from '@parapet/common';

export const selectStyles: StylesConfig<any> = {
  control: (styles) => ({
    ...styles,
    // backgroundColor: 'lime',
    backgroundColor: 'transparent',
    minWidth: '52px',
    marginBottom: '-14px',
    paddingLeft: '18px',
    borderRadius: '4px',
    borderColor: 'transparent',
    cursor: 'pointer',
    color: '#fff',
    boxShadow: 'none',
    ':hover': {
      borderColor: 'transparent',
      boxShadow: 'none',
      '.rc__indicator': {
        color: 'var(--input-border-color-hover)',
      },
    },
    ':focus': {
      borderColor: 'transparent',
    },
    '&.rc__control--menu-is-open .rc__indicator': {
      transform: 'translateY(1px) rotate(180deg)',
    },
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    color: 'var(--input-border-color)',
    border: 0,
    ':hover': {
      color: 'var(--input-border-color)',
    },
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  menuList: (styles) => ({
    ...styles,
    width: '320px',
    backgroundColor: 'var(--input-bg)',
  }),
};

export const StyledPhoneWithCountryCodeInput = styled.div<{
  hasFocus: boolean;
}>`
  width: 100%;
  height: 52px;
  border-bottom: 1px solid var(--input-border-color);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  input {
    padding-left: 0;
    padding-bottom: 0;
    border-color: transparent !important;
  }
  ${({ hasFocus }) =>
    hasFocus &&
    css`
      border-bottom: 1px solid var(--primary-500);
    `};
`;

export const SelectContainer = styled.div`
  min-width: 82px;
  padding-bottom: 4px;
  white-space: nowrap;
`;

export const CodesLoadingIndicator = styled.div`
  position: relative;
  top: 6px;
  right: 10px;
  svg {
    fill: var(--primary-500);
  }
`;

export const StyledSelectOption = styled.div<{
  isSelected: boolean;
  isPrimary: boolean;
}>`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 13px;
  border-radius: 4px;
  color: #ccc;
  &:hover {
    color: #fff;
    > span {
      transform: scale(1.2);
    }
  }
  > span {
    font-size: 18px;
  }
  ${({ isSelected }) =>
    isSelected &&
    css`
      background-color: var(--primary-500);
      color: #fff;
    `}
  ${({ isPrimary }) =>
    isPrimary &&
    css`
      background-color: #0001;
      color: #eee;
    `}
`;

// export const InvalidPattern = styled.div`
//   height: 38px;
//   font-size: 12px;
//   color: var(--input-error-text, red);
//   display: flex;
//   align-items: center;
//   justify-content: center;
// `;
